<template>
  <section id="about" class="about">
    <div class="container">
      <div class="header">
        <h6 class="small-title">{{ $t('about.subtitle') }}</h6>
        <h2 class="main-title" v-scroll-reveal>{{ $t('about.title') }}</h2>
      </div>
      
      <div class="about-tabs">
        <div class="tab-nav" role="tablist" aria-label="About us">
          <button 
            v-for="tab in ['who', 'vision', 'history']" 
            :key="tab"
            @click="activeTab = tab"
            :class="{ active: activeTab === tab }"
            role="tab"
            :aria-selected="activeTab === tab"
            :aria-controls="`tabpanel-${tab}`"
            :id="`tab-${tab}`"
          >
            {{ $t(`about.${tab === 'who' ? 'whoWeAre' : tab}.title`) }}
          </button>
        </div>
        
        <div class="tab-content">
          <div v-if="activeTab === 'who'" class="pane" role="tabpanel" id="tabpanel-who" aria-labelledby="tab-who">
            <p>{{ $t('about.whoWeAre.text') }}</p>
          </div>
          <div v-if="activeTab === 'vision'" class="pane" role="tabpanel" id="tabpanel-vision" aria-labelledby="tab-vision">
            <p>{{ $t('about.vision.text') }}</p>
          </div>
          <div v-if="activeTab === 'history'" class="pane" role="tabpanel" id="tabpanel-history" aria-labelledby="tab-history">
            <p>{{ $t('about.history.text') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const activeTab = ref('who')
</script>

<style scoped>
.about {
  padding: 80px 20px;
  background-color: var(--white);
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 50px;
}

.small-title {
  color: var(--primary-color);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.main-title {
  font-size: 2.5rem;
  color: var(--text-color);
}

.about-tabs {
  background: var(--gray-light);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}

.tab-nav {
  display: flex;
  background: #eee;
}

.tab-nav button {
  flex: 1;
  padding: 15px;
  border: none;
  background: none;
  cursor: pointer;
  font-weight: 600;
  color: var(--text-color);
  transition: all 0.3s;
  border-bottom: 3px solid transparent;
}

.tab-nav button.active {
  background: var(--white);
  color: var(--primary-color);
  border-bottom-color: var(--primary-color);
}

.tab-content {
  padding: 40px;
  background: var(--white);
  min-height: 200px;
}

.pane p {
  line-height: 1.8;
  font-size: 1.1rem;
  color: var(--text-color);
  white-space: pre-line;
}

@media (max-width: 768px) {
  .tab-nav {
    flex-direction: column;
  }
}
</style>
